module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_add-to-unscopables.js
// module id = 35
// module chunks = 0 1 2 3